import React, { useEffect, useState } from 'react';
import {unblockContractStatusApi} from '../../services/business-partner-api';
import UnblockCrSuccess from '../../components/UI/Modal/UnblockCrSuccess'

function UnblockCrStatus(props) {

    const [apiData,setApiData]=useState([]);


    useEffect(() => {        
        async function unblockContractStatusHandler() {
            await unblockContractStatusApi(props.BusinessPartnerCode)
            .then((data) => {
                if(data && data.length>0){
                    setApiData(data);
                }else{
                    props.setShowUnblockModel();
                }
                    
            })
            .catch((error) => {
                setApiData([]);
                props.setShowUnblockModel();
            })
        }
        if(props.showUnblockModel){
            unblockContractStatusHandler();
        }
    }, []);

    return (
            apiData && apiData.length>0 ? <UnblockCrSuccess statusData={apiData} setShowUnblockModel={props.setShowUnblockModel}/> : null
    );
}

export default UnblockCrStatus;